exports = module.exports = require("../../../../../../employee/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* otp */\n.otp-text {\n  margin-bottom: 12px; }\n\n.otp-heading {\n  margin-bottom: 24px; }\n\n.otp-prompt,\n.otp-resend {\n  display: inline-block;\n  margin-left: 10px; }\n\n.otp-resend .label-text {\n  color: #fe7a51; }\n\n.otp-prompt .label-text {\n  color: \"rgba(0, 0, 0, 0.6000000238418579)\"; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/User/components/OTPForm/index.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!../lib/egov-ui-kit/common/User/components/OTPForm/index.css
// module chunks = 504